import React, { useState, useEffect } from 'react';

// Import CSS & assets
import './Chat.css';



const MessageUser = ({ message }) => {


    return (
        <div className="app__chat_messageuser_container">
            <div className="app__chat_messageuser_bubble">
                {message?.content}
            </div>
        </div>
    );
};

export default MessageUser;